import { optional } from '@/helpers/dto2resource';
import { LimitesDto } from '../dto/DetalheOfertaDto';

class LimitesResource {
  limiteAnterior?: number;
  descricaoStatusLimite?: string;
  valorLimitePagamento?: number;
  valorLimitePromessa?: number;

  constructor(dto: LimitesDto) {
    this.limiteAnterior = optional(dto.limiteAnterior);
    this.descricaoStatusLimite = optional(dto.descricaoStatusLimite);
    this.valorLimitePagamento = optional(dto.valorLimitePagamento);
    this.valorLimitePromessa = optional(dto.valorLimitePromessa);
  }

  validar(): boolean {
    return (this.limiteAnterior != null && this.limiteAnterior !== 0)
    || (this.descricaoStatusLimite != null && this.descricaoStatusLimite !== '')
    || (this.valorLimitePagamento != null && this.valorLimitePagamento !== 0)
    || (this.valorLimitePromessa != null && this.valorLimitePromessa !== 0);
  }
}

export default LimitesResource;
